import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select, Pagination } from 'components';
import { OrderService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { ArrowLeftWhite, CleanIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalViewOrder extends React.Component<Props> {

	state = {
		item: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await OrderService.admin.view({
			order_id: this.props.item?.id
		});
		this.setState({
			item: res.order
		});
	}

	render() {
		const item: any = this.state.item;

		return (
			<div id="modal-view-order">
				<h3>Pedido</h3>
				<div className="row row-header">
					<div className="col-md-6">
						<p><span>Cliente:</span> { item?.user?.full_name }</p>
						<p><span>Teléfono:</span> { item?.user?.phone }</p>
						<p><span>RIF/C.I.:</span> { item?.user?.full_document }</p>
					</div>
					<div className="col-md-6 text-right">
						<p className="number">Nº { item?.number }</p>
						<p>{ moment(item?.created_at).format('DD-MM-YYYY') }</p>
					</div>
				</div>
				<div className="container-table">
					<table className="table-details">
						<tr>
							<th>Producto</th>
							<th className="text-center">Presentación</th>
							<th className="text-center">Cantidad</th>
							<th className="text-center">Precio</th>
							<th className="text-right">Subtotal</th>
						</tr>
						{
							item?.details?.map((i: any) => {
								return (
									<tr>
										<td>{ i?.product?.name }</td>
										<td className="text-center">{ i?.product?.type_id == Constants.PRODUCT_TYPES.PRODUCT ? i?.product?.presentation?.name : '-' }</td>
										<td className="text-center">{ i?.quantity }</td>
										<td className="text-center">{ Globals.formatMiles(i?.price) }</td>
										<td className="text-right">{ Globals.formatMiles(i?.total) }</td>
									</tr>
								)
							})
						}
					</table>
				</div>
				<div className="container-total">
					<table>
						<tr>
							<td>
								<p className="subtotal">Subtotal</p>
							</td>
							<td>
								<p className="subtotal">{ Globals.formatMiles(item?.subtotal) }</p>
							</td>
						</tr>
						<tr>
							<td>
								<p className="iva">IVA ({ item?.iva_percentage }%)</p>
							</td>
							<td>
								<p className="iva">{ Globals.formatMiles(item?.iva) }</p>
							</td>
						</tr>
						<tr>
							<td>
								<p className="total">Total</p>
							</td>
							<td>
								<p className="total">{ Globals.formatMiles(item?.total) }</p>
							</td>
						</tr>
					</table>
				</div>
				<div className="text-center">
					<Button type="button" className="btn-cancel" onClick={ () => this.props.onClose() }>
						Cerrar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalViewOrder;